module.exports = __webpack_public_path__ + "assets/img/map-view.e73e90b5.png";